import * as React from 'react';
import UzPravaPrj from './akc/UzPravaPrj';
import PravaPrj from './akc/PravaPrj';
import PravaUz from './akc/PravaUz';
import PravaSkup from './akc/PravaSkup';
import Seq from './akc/Seq';
import UpdateStoringSchema from './akc/UpdateStoringSchema';
import UzWizard from './akc/UzWizard';
import UiDesigner from './akc/UiDesigner';
import OdblokUz from './akc/OdblokUz';
import { useMetaState } from './MetaStateContext';

const AkcContainer = ({ akc, primaryField, obj, showMsg, db }) => {
  const selected = useMetaState(`${primaryField}.selected`);

  switch (akc.IAkc) {
    case 51:
      return (
        <PravaPrj
          selected={selected}
          db={db}
          showMsg={showMsg}
          primaryField={primaryField}
        />
      );
    case 52:
      return (
        <PravaSkup
          selected={selected}
          db={db}
          showMsg={showMsg}
          primaryField={primaryField}
        />
      );
    case 56:
      return (
        <PravaUz
          selected={selected}
          db={db}
          showMsg={showMsg}
        />
      );
    case 57:
      return (
        <UzWizard
          db={db}
          selected={selected}
          akc={akc}
        />
      );
    case 58:
      return (
        <Seq
          db={db}
          selected={selected}
          showMsg={showMsg}
        />
      );
    case 59:
    return (
        <UpdateStoringSchema
          db={db}
          selected={selected}
          showMsg={showMsg}
        />
      );
    case 60:
      return (
        <UiDesigner
          selected={selected}
          akc={akc}
          showMsg={showMsg}
          obj={obj}
        />
      );
    case 61:
      return (
        <OdblokUz
          primaryField={primaryField}
          selected={selected}
          akc={akc}
          showMsg={showMsg}
          obj={obj}
          db={db}
        />
      );
    case 99:
      return (
        <UzPravaPrj
          selected={selected}
          db={db}
          primaryField={primaryField}
          showMsg={showMsg}
        />
      );
    default:
      return null;
  }
};

const akcFactory = (akc, primaryField, showMsg, obj, customAkcFactory) => {
  const customAkc = customAkcFactory ? customAkcFactory(akc, primaryField, showMsg, obj) : null;
  if (customAkc) return customAkc;

  return <AkcContainer akc={akc} primaryField={primaryField} db={obj.db} showMsg={showMsg} obj={obj} />;
};

export default akcFactory;